import { Route } from 'react-router-dom';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
// @ts-expect-error migrate upstream
import DashboardContainer from '../components/routes/DashboardContainer';
// @ts-expect-error migrate upstream
import EmailUnsubscribe from '../components/routes/EmailUnsubscribe';
import { RouteKeys } from '../constants/route/DashboardRoute';

// @ts-expect-error migrate upstream
import { jsx as _jsx } from "react/jsx-runtime";
const loadExportDashboardRoute = () => import(
// @ts-expect-error migrate upstream
/* webpackChunkName: "Export" */
'dashboard-ui-components/components/routes/ExportDashboardRoute');
const AsyncExportRoute = Loadable({
  loader: loadExportDashboardRoute,
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingSpinner, {
    minHeight: 300
  })
});
const Components = {
  [RouteKeys.DASHBOARD]: DashboardContainer,
  [RouteKeys.EXPORT]: AsyncExportRoute,
  [RouteKeys.EMAIL_UNSUBSCRIBE]: EmailUnsubscribe
};
export const createDashboardRoute = config => {
  const {
    key
  } = config;
  return /*#__PURE__*/_jsx(Route, Object.assign({
    component: Components[key]
  }, config));
};